import { Helmet } from "react-helmet-async";

const SEOHead = ({ 
  title, 
  description, 
  keywords, 
  image, 
  article, 
  publishedTime, 
  author = "FinaNews",
  type = "website" 
}) => {
  const lang = "pt-BR";
  const baseUrl = window.location.origin;
  const currentUrl = window.location.href;

  const siteTitle = "FinaNews - Notícias de Finanças Pessoais";
  const siteDescription = "Fique atualizado com as últimas notícias de finanças pessoais, investimentos, economia e criptomoedas. Atualizado a cada 30 minutos de fontes confiáveis.";
  const defaultImage = `${baseUrl}/og-image.png`;

  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
  const metaDescription = description || siteDescription;
  const metaImage = image || defaultImage;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <html lang={lang} />
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="author" content={author} />
      <link rel="canonical" href={currentUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:site_name" content="FinaNews" />
      <meta property="og:locale" content="pt_BR" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={currentUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />

      {/* Article specific tags */}
      {article && (
        <>
          <meta property="article:published_time" content={publishedTime} />
          <meta property="article:author" content={author} />
          <meta property="article:section" content="Finanças" />
        </>
      )}

      {/* Language alternatives */}
      <link rel="alternate" hrefLang="pt-BR" href={currentUrl} />
      <link rel="alternate" hrefLang="x-default" href={currentUrl} />

      {/* Mobile */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="theme-color" content="#064E3B" />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
    </Helmet>
  );
};

export default SEOHead;